import React from "react";
import useIsMobile from "./useIsMobile.js";
import AppButton from "./AppButton.jsx";
import { Input } from "../forms/shared/FormAtoms.jsx";
import { cn } from "../../utils/themeClasses.js";

/**
 * Einheitliches Suchfeld für BlockSectionToolbar (kompakt auf Mobile via Toolbar-Normalize).
 */
export default function BlockSectionSearch({
  value,
  onChange,
  onClear,
  placeholder = "Suche…",
  title,
  ariaLabel = "Suchen",
  className = "",
  wrapperClassName = "relative w-full min-w-0 flex-1 md:min-w-[10rem]",
}) {
  const isMobile = useIsMobile();
  const trim = String(value ?? "").trim();
  const clear = onClear ?? (() => onChange?.({ target: { value: "" } }));

  return (
    <div className={wrapperClassName}>
      <Input
        type="text"
        inputMode="search"
        autoComplete="off"
        enterKeyHint="search"
        placeholder={placeholder}
        title={title ?? placeholder}
        value={value}
        onChange={onChange}
        className={cn(
          "px-3 py-2 w-full text-sm [appearance:textfield] [&::-webkit-search-cancel-button]:hidden",
          trim ? "pr-10" : "pr-3",
          className,
        )}
        style={isMobile ? { fontSize: "16px" } : undefined}
        aria-label={ariaLabel}
        role="searchbox"
      />
      {trim ? (
        <AppButton
          type="button"
          variant="ghost"
          onClick={clear}
          className="absolute right-1 top-1/2 -translate-y-1/2 !min-h-8 !min-w-8 !p-0 !border-0 !bg-transparent !shadow-none text-blue-200/70 hover:!bg-transparent hover:text-white"
          aria-label="Suche löschen"
          title="Suche löschen"
        >
          ✕
        </AppButton>
      ) : null}
    </div>
  );
}
